import { saveAs } from 'file-saver';

export default async function downloadBlob(url, name) {
  const res = await fetch(url, { method: 'GET' });
  const blob = await res.blob();
  saveAs(blob, name);
}
